import { render, staticRenderFns } from "./YoungComment.vue?vue&type=template&id=1937aa04&scoped=true&"
import script from "./YoungComment.vue?vue&type=script&lang=js&"
export * from "./YoungComment.vue?vue&type=script&lang=js&"
import style0 from "./YoungComment.vue?vue&type=style&index=0&id=1937aa04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937aa04",
  null
  
)

export default component.exports